module.exports = __webpack_public_path__ + "static/media/1-2.0a74ac5a.svg";